<main class="mobile_ordered">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('ordered_history_title')}}</h1>
            <span class="icon back" @click="app.setPage('Menu')">
                chevron_left
            </span>
        </div>
    </header>

    <table class="c-table">
        <thead>
            <th class="first_cell">{{ _('building_name') }}</th>
            <th class="purchase_date">{{ _('purchase_date') }}</th>
            <th class="purchase_number">{{ _('quantity') }}</th>
            <th class="merchandise_price">{{ _('merchandise_price') }}</th>
        </thead>
        <tbody>
            <tr v-for="order in orders">
                <td class="merchandise_name">
                    {{ _(order.title) }}
                    <p v-if="schedule(order)">{{ schedule(order) }}</p>
                </td>
                <td>{{ order.order_date }}</td>
                <td>{{ order.quantity }}{{ _(order.unit) }}</td>
                <td class="merchandise_price">
                    {{ order.amountIncludingTax() | price }}
                </td>
            </tr>
            <!-- gratuity_orders -->
            <tr v-for="order in gratuity_orders">
                <td class="merchandise_name">{{ _('gratuity_payment') }}</td>
                <td>{{ order.created }}</td>
                <td></td>
                <td class="merchandise_price">{{ order.amount | price }}</td>
            </tr>
            <!-- gratuity_orders -->
        </tbody>
        <tfoot>
            <tr>
                <th class="first_cell">
                    {{_('total')}}（{{ _('include_tax') }}
                </th>
                <th></th>
                <th></th>
                <th class="merchandise_price">
                    <h3>{{totalOrderedPrice() | price}}</h3>
                </th>
            </tr>
        </tfoot>
    </table>
    <div class="button next-buttons">
        <button class="skeleton" @click="app.setPage('MerchandiseCategories')">
            {{_('continue_shopping')}}
        </button>
        <button class="skeleton" @click="app.setPage('Menu')">
            {{_('return_to_my_page')}}
        </button>
    </div>
    <template v-if="_(app.house.mobile_order_caution)">
        <hr />
        <section class="remarks">
            <pre>{{ _(app.house.mobile_order_caution) }}</pre>
        </section>
        <hr />
    </template>
    <tab-bar :page="app.query.page"></tab-bar>
</main>
